<template>
  <PageContentLayoutOnly headerColor="#fafafa">
    <div>
      <div class="pb-3">
        <button
          @click.prevent="saveDescription(true)"
          :disabled="hasReadonly"
          class="button is-primary is-rounded"
        >
          Save
        </button>
      </div>
      <div workorderdetails class="notification headerColor" v-if="formData">
        <div class="box is-12">
          <ValidationObserver ref="form" v-slot="{ handleSubmit }">
            <transition name="fade" mode="out-in" appear>
              <form @submit.prevent="handleSubmit(saveDescription)" class="form">
                <fieldset>
                  <div class="columns">
                    <div v-if="mailingType === 'Mail'" class="column is-12">
                      <b-field label="Mailing Types">
                        <b-select
                          @blur="changeMailingsByMailType()"
                          v-model="formData.mailingTypeID"
                          required="true"
                          :disabled="hasReadonly"
                          placeholder="Select a Mailing Type"
                        >
                          <option
                            v-for="option in mailingTypeList"
                            :value="option.value"
                            :key="option.value"
                          >
                            {{ option.label }}
                          </option>
                        </b-select>
                      </b-field>
                    </div>
                  </div>
                  <div v-show="false" v-if="mailingType === 'Mail'">
                    <b-field label="Legal Communication Forms">
                      <b-checkbox
                        v-model="formData.isLegalCommunication"
                        :native-value="formData.isLegalCommunication"
                        @click.native="processIsLegalCommunication"
                        :disabled="hasReadonly"
                      >
                        <div>&nbsp;</div>
                        <div>
                          Is this a legal communication that requires delivery via US Postal Mail?
                        </div>
                        <div class="small-red-text">
                          For legal communications, postal communication is mandatory.
                        </div>
                      </b-checkbox>
                    </b-field>
                  </div>
                  <div>&nbsp;</div>
                  <b-field
                    label="Description"
                    :message="
                      !formData.description && descriptionIsStarted ? 'Description is required' : ''
                    "
                    :type="!formData.description && descriptionIsStarted ? 'is-danger' : 'none'"
                  >
                    <textarea
                      ref="textarea"
                      class="textarea"
                      :maxlength="250"
                      :disabled="hasReadonly"
                      v-model="formData.description"
                      @blur="descriptionBlur"
                    />
                  </b-field>
                </fieldset>
                <fieldset>
                  <ValidationProvider vid="providerErrors" v-slot="{ errors }">
                    <div class="field">
                      <span>{{ errors[0] }}</span>
                    </div>
                  </ValidationProvider>
                </fieldset>
              </form>
            </transition>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </PageContentLayoutOnly>
</template>

<script>
import PageContentLayoutOnly from '@/containers/PageContentLayoutOnly'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { mapState, mapGetters } from 'vuex'
import { data } from './keys/data'
import { methods } from './keys/methods'

export default {
  name: 'AddEditCommunication',
  components: {
    ValidationObserver,
    ValidationProvider,
    PageContentLayoutOnly
  },

  data,

  computed: {
    ...mapState({
      hoaId: state => state.user.selectedHoaId,
      ...mapGetters('user', ['authUser']),
      ...mapGetters('communication', [
        'supportMailDelivery',
        'supportEmailDelivery',
        'supportSMSDelivery',
        'isLegalCommunication',
        'mailingTypeID',
        'mailingCommunicationID',
        'mailMessage',
        'emailMessage',
        'emailMessageSubject',
        'communicationDescription',
        'deliveryDate',
        'isFullDuplex',
        'isColor',
        'mailingType',
        'hasReadonly'
      ])
    })
  },

  mounted() {
    console.debug('in general info mounted.....')
    this.wasAdded = false
    if (this.$route.query.readonly !== undefined) {
      this.isReadOnly = this.$route.query.readonly || false
    }

    console.debug('general info isReadOnly=' + this.isReadOnly)

    this.reload()

    this.loadMailingTypeList()

    setTimeout(() => {
      this.populateFromState()
    }, 1000)
  },

  watch: {
    hoaId() {
      this.reload()
    },
    'formData.description'() {
      this.saveDescriptionChange()
    },
    'formData.isLegalCommunication'() {
      this.saveDescription(false)
    },
    'formData.mailingTypeID'() {
      this.saveDescription(false)
    }
  },

  methods,

  i18n: {
    messages: {
      en: {
        workOrderUpdate: { title: 'Save Work Order' },
        photos: { title: 'Photos' },
        notes: { title: 'Notes' }
      }
    }
  }
}
</script>

<style lang="scss">
#update-work-order .my-grid-class {
  height: 400px;
}

#update-work-order tbody {
  min-height: 100px !important;
  overflow: auto !important;
}
</style>
